import {
  WIDTH_LG, WIDTH_MD, WIDTH_SM, WIDTH_XL
} from "../utils/constants";

import React, { useEffect, useState } from "react";

export const useResize = () => {

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {

    const handleResize = (e) => {
      setWidth(e.target.innerWidth);
    }
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (width > WIDTH_LG.width) {
    return { currWidthName: WIDTH_XL.name, currWidth: width }
  } else if (width > WIDTH_MD.width) {
    return { currWidthName: WIDTH_LG.name, currWidth: width };
  } else if (width > WIDTH_SM.width) {
    return { currWidthName: WIDTH_MD.name, currWidth: width };
  } else {
    return { currWidthName: WIDTH_SM.name, currWidth: width };
  }
}
